import { useNavigateTo } from './useNavigateTo'
import usePartVideo from './usePartVideo'

export default function useNavigateToShortVideo() {
  const { checkShortMasonryVideo } = usePartVideo()
  const { navigateToViewShort } = useNavigateTo()
  const navigateToViewShortWithPartVideoCheck = async (info) => {
    //
    const list = info.videoList?.map((m) => m.id)
    const check = await checkShortMasonryVideo({
      id: info.videoInfo.id,
      list,
      onOk: () => {},
      onCancel: () => {
        navigateToViewShort(info)
      },
    })
    if (check) {
      navigateToViewShort(info)
    }
  }
  return { navigateToViewShortWithPartVideoCheck }
}
